import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function PageMetadata({ title, description }) {
  useEffect(() => {
    document.title = title;
    const update = (attribute, name, content) => {
      let tag = document.head.querySelector(`meta[${attribute}="${name}"]`);
      if (!tag) { tag = document.createElement('meta'); tag.setAttribute(attribute, name); document.head.appendChild(tag); }
      tag.content = content;
    };
    update('name', 'description', description);
    update('property', 'og:title', title);
    update('property', 'og:description', description);
  }, [title, description]);
  return null;
}

export function RouteScroll() {
  const { pathname, hash, key } = useLocation();
  useEffect(() => {
    const target = hash && document.getElementById(hash.slice(1));
    if (target) target.scrollIntoView({ behavior: 'smooth' });
    else window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname, hash, key]);
  return null;
}
